import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { GeneralService } from './shared/services/general.service';
import { APIServerResponse } from './shared/models/ApiModels';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'School_Template';
  currentDomain: string;

  constructor(private location: Location,private genService:GeneralService) {
    
  }

  ngOnInit(): void {
    this.currentDomain = window.location.hostname;
    if(this.currentDomain)
    {
      this.getSchoolIdByUrl(this.currentDomain); 
    }
    
    
  };



  getSchoolIdByUrl(hostname:any) {
    this.genService.getSchoolIdByUrl(hostname).subscribe((res:any) => {
      if (res.data != null) {
        if(res.data)
        {
          sessionStorage.setItem("schoolId",res.data.id);
        }
      }
    })
  }
  
}
